import styled from "styled-components";


interface IContainerGrupoNv2 {
    colorBar: string;
}

export const ContainerGrupoNv2 = styled.div<IContainerGrupoNv2>`

    flex: 1 1 100%;
    flex-flow: row;
    color: rgb(252, 252, 252);
    min-height: 50px;
    max-height: 50px;
    height: 50px;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    display: flex;
    position: relative;
    overflow-x: scroll;
    margin: 10px 0px 0px;
    padding: 3px 0px;
    text-overflow: ellipsis;
    border-radius: 0px;
    border: none;
    overflow-wrap: break-word;
  
  
  &::-webkit-scrollbar {
    width: 10px;
    display: flex !important;
  }
  

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.colorBar || 'red'};
    border-radius: 10px;
  }
  
 
  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.colorBar || 'red'};
  }
  
`;
